import { lazy } from "react";
import { ICON_TYPE } from "components/icons/icon";
import { DateRangeSupport } from "helpers/shared/formatters/dates";
import { HQ_FEATURE_FLAGS } from "types/context";
import type { ISectionProps } from "types/navigation";

export const FINANCIAL_SERVICES_PATH = "/financial_services";

export const PAYMENT_ONBOARDING_PATH =
  `${FINANCIAL_SERVICES_PATH}/payments_onboarding` as const;

export const FINANCIAL_SERVICES: ISectionProps = {
  feature: "Financial Services",
  icon: ICON_TYPE.CAPITAL,
  component: lazy(() =>
    import("containers/lspay/financial_services_containers").then((module) => ({
      default: module.MerchantPortalContainer,
    }))
  ),
  path: FINANCIAL_SERVICES_PATH,
  subSections: [
    {
      feature: "Payments Onboarding",
      level: ["store"],
      scope: ["staff", "superuser"],
      path: PAYMENT_ONBOARDING_PATH,
      dateSupport: DateRangeSupport.NONE,
      component: lazy(() =>
        import("containers/lspay/financial_services_containers").then(
          (module) => ({
            default: module.PaymentOnboardingPortalContainer,
          })
        )
      ),
    },
  ],
  requiresFeatureFlag: HQ_FEATURE_FLAGS.adyenMerchantPortal,
  dateSupport: DateRangeSupport.NONE,
  level: ["store"],
  secondaryNavigationDisabled: true,
};
